/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.presentation.common.model

enum class WeekAlternationOption {
    ALL,
    BOTH,
    NUMERATOR,
    DENOMINATOR
}